import { render } from "./ClassMessagesReport.vue?vue&type=template&id=4165e412&scoped=true"
import script from "./ClassMessagesReport.vue?vue&type=script&lang=js"
export * from "./ClassMessagesReport.vue?vue&type=script&lang=js"

import "./ClassMessagesReport.vue?vue&type=style&index=0&id=4165e412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4165e412"]])

export default __exports__